module.exports = __webpack_public_path__ + "static/media/hse-banner.0f4e4bd4.jpg";